import React, { useState, useEffect } from 'react'
import { Button, Form, Input, message } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { translations } from '../../utils/constants'
import { POST } from '../../utils/apis'
import { secureApi } from '../../Config/api'
import { loginUser } from '../../Redux/actions/authActions'

const Profile = ({ language }) => {
    const dispatch = useDispatch()
    const authUser = useSelector(state => state?.authReducer?.user)
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    useEffect(() => {
        if (authUser) {
            form.setFieldsValue({
                userName: authUser?.userName || '',
                email: authUser?.email || '',
                role: authUser?.role || ''
            })
        }
    }, [authUser, form])

    const onFinish = async (values) => {
        try {
            setLoading(true)
            const response = await secureApi.post(POST?.UPDATE_USER, {
                userId: authUser?.id,
                userName: values?.userName
            })
            if (response?.success === true) {
                dispatch(loginUser({
                    ...authUser,
                    userName: values.userName
                }))
                message.success(translations[language]?.profileUpdated)
            } else {
                message.error(translations[language]?.unexpectedError)
            }
        } catch (error) {
            const errMessage =
                error?.response?.message || 'An error occurred. Please try again later.'
            message.error(errMessage)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div>
            <div className='setting-inner-div'>
                <Form
                    name='form'
                    onFinish={onFinish}
                    layout='vertical'
                    requiredMark={true}
                    form={form}
                    initialValues={{
                        userName: authUser?.userName || '',
                        email: authUser?.email || '',
                        role: authUser?.role || ''
                    }}
                >
                    <div className='SettingInp'>
                        <div className='settingInput'>
                            <Form.Item
                                label={translations[language]?.name || 'Name'}
                                name='userName'
                                rules={[{
                                    required: true,
                                    message: translations[language]?.pleaseEnterName
                                }]}
                            >
                                <Input
                                    placeholder={translations[language]?.name || 'Name'}
                                    className='custom-inputs'
                                />
                            </Form.Item>
                        </div>

                        <div className='settingInput'>
                            <Form.Item
                                label={translations[language]?.email || 'Email'}
                                name='email'
                            >
                                <Input disabled className='custom-inputs' />
                            </Form.Item>
                        </div>
                    </div>

                    <div className='setting-input'>
                        <Form.Item
                            label={translations[language]?.role || 'Role'}
                            name='role'
                        >
                            <Input disabled className='custom-inputs' />
                        </Form.Item>
                    </div>

                    <Form.Item style={{ width: '100%', textAlign: 'end' }}>
                        <Button
                            type='primary'
                            htmlType='submit'
                            loading={loading}
                            className='export-btn setting-button'
                        >
                            {translations[language]?.saveChagnes}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}

export default Profile
